module.exports = __webpack_public_path__ + "img/svg.9dea8d1d.svg";